import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import CategoryLinksList from "./CategoryLinksList";
import styles from "./CategoryHeaderLinks.css";
import HorizontalScrollListVariant from "../../HorizontalScrollList/components/HorizontalScrollListVariant";
import { getCategorySeoLinks } from "../../../state/modules/category/selectors";
import { MIN_SEO_LINKS } from "../../constants";
import { withTranslation } from "../../translation";

const CategoryHeaderLinks = ({ formatTranslation }) => {
  const { primarySeoLinks } = useSelector(getCategorySeoLinks);
  if (primarySeoLinks.length < MIN_SEO_LINKS) return null;

  return (
    <span className={styles.list}>
      <HorizontalScrollListVariant
        scrollSnapping={false}
        className={styles.categoryHeaderLinks}
        ariaLabel="plp_web_a11y_category_carousel"
        formatTranslation={formatTranslation}
      >
        <CategoryLinksList links={primarySeoLinks} />
      </HorizontalScrollListVariant>
    </span>
  );
};

CategoryHeaderLinks.propTypes = {
  formatTranslation: PropTypes.func.isRequired
};

export default withTranslation(CategoryHeaderLinks);
